module.exports = __webpack_public_path__ + "img/InsT.2a76ef37.svg";